import React, { Fragment, useEffect, useState } from "react";
import styles from "Components/Topology/topology.module.scss";
import { Form, Select, Row, Col, Divider, InputNumber } from "antd";
import { useAppSelector } from "store/hook";
import { setFields, SYSTEMProps } from "./setField";

const { Option } = Select;

// alarm type DI 跟設備 system 的 Dying Gasp 不能同時 enable
const M352Type = [
  { value: "sms", name: "SMS" },
  { value: "vpn-disconnect", name: "VPN disconnect" },
  { value: "wan-disconnect", name: "WAN disconnect" },
  { value: "lan-eth-disconnect", name: "LAN disconnect" },
  { value: "reboot", name: "Reboot" },
  { value: "di", name: "DI" },
];

const AlarmM352 = React.memo(({ SubmitConfigonFinish, form }: SYSTEMProps) => {
  const [AlarmEnable, setAlarmEnable] = useState<boolean>(false);
  const [AlarmType, setAlarmType] = useState<string[]>([]);
  const { formData, importSource } = useAppSelector((state) => state.topology);

  const alarm = formData?.system?.alarm;
  useEffect(() => {
    setAlarmEnable(alarm?.mode || false);
    setAlarmType(alarm?.inputs);

    if (importSource === "NewConfig") {
      return;
    }

    setFields(alarm, form);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData]);

  return (
    <Form onFinish={SubmitConfigonFinish} form={form} scrollToFirstError layout="vertical">
      <div className="formwrap">
        <Row gutter={24} justify="space-around">
          <Col xs={24} sm={24} md={24} lg={24} xl={10}>
            <h2>Type</h2>
            <Divider className={styles.divider} />
            <Form.Item
              name={"alarm_enabled"}
              label="Alarm Enable"
              rules={[{ required: true, message: "required!" }]}
              initialValue={false}
              // dependencies={['alarm_input']}
            >
              <Select
                onChange={(value: any) => {
                  setAlarmEnable(value);
                  form.validateFields(["alarm_input", "gps_radius", "gps_latitude", "gps_longitude"]);
                }}
                placeholder={"ON/OFF"}
              >
                {/* @ts-ignore */}
                <Option key={0} value={true}>
                  ON
                </Option>
                {/* @ts-ignore */}
                <Option key={1} value={false}>
                  OFF
                </Option>
              </Select>
            </Form.Item>

            <Form.Item
              name={"alarm_input"}
              label="Type"
              rules={[{ required: AlarmEnable, message: "required!" }]}
              initialValue={["sms"]}
              // validateTrigger={['alarm_enabled']}
            >
              <Select
                onChange={(value: string[]) => {
                  setAlarmType(value);
                }}
                mode="multiple"
                maxTagCount={"responsive"}
                placeholder={"SMS , Reboot ...."}
                disabled={!AlarmEnable}
              >
                {M352Type.map((item, index) => {
                  // if (item.value === "geofence" && !hasGPS) {
                  //   return;
                  // }
                  return (
                    <Option key={index} value={item.value}>
                      {item.name}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={10}></Col>
        </Row>
      </div>
    </Form>
  );
});

export default AlarmM352;

////////////////////////////////////////////

export function assemble(values: any) {
  let alarm: any = {
    mode: values.alarm_enabled,
  };

  if (values.alarm_enabled) {
    alarm.inputs = values.alarm_input;
  }

  const system = {
    alarm: alarm,
  };

  return system;
}
